import React, { useState, useContext, useEffect, useRef } from 'react';
import {
  Box,
  Grid,
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  InputLabel,
  Select as MuiSelect,
  MenuItem,
} from '@mui/material';

import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../context/Context';

import toast from 'react-hot-toast';
import { SocketNFCContext } from '../../context/SocketNFC';
import { SocketContext } from '../../context/SocketContext';
import { useTranslation } from 'react-i18next';
import {
  headerCellSx,
  dataRowSx,
  touchMenuProps,
} from '../../theme/tableTokens';
import TouchButton from '../../components/TouchButton/TouchButton';
import SearchIcon from '@mui/icons-material/Search';
import 'react-calendar/dist/Calendar.css';

import TableLoader from '../../components/TableLoader/TableLoader';
import '../../assets/css/buttons.css';


function SisteKortTransaksjoner() {
  const dateInputRef = useRef(null);
  const { socket } = useContext(SocketContext);
  const { t } = useTranslation();

  const navigate = useNavigate();
  const { isLogin, isBlocking, BlockingScreen, hall, printer } =
    useContext(AppContext);

  useEffect(() => {
    if (!isLogin) {
      navigate('/login');
    }
  }, []);

  const [rows, setRows] = useState(false);
  const [rowsFiltered, setRowsFiltered] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [searchType, setSearchType] = useState('username');

  const searchTypeLabel = {
    username: t('sisteSalgs.username'),
    name: t('pep.name'),
    userID: t('sisteSalgs.userID'),
    ticketID: t('sales.ticketSaleID'),
    description: t('sisteTrans.description'),
    time: t('sales.time'),
  };
  const [searchValue, setSearchValue] = useState('');
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));

  useEffect(() => {
    const handleShoppingCarts = (data) => {
      setRows(data || []);
      setIsLoading(false);
    };

    socket.on('getLastCardTransactions', handleShoppingCarts);

    return () => {
      socket.off('getLastCardTransactions', handleShoppingCarts);
    };
  }, [socket]);

  useEffect(() => {
    socket.emit('getLastCardTransactions', {
      bingoName: hall,
      date: new Date().toISOString().slice(0, 10),
    });
  }, [hall]);

  useEffect(() => {
    if (!rows) return;
    let filtered = Array.isArray(rows)
      ? rows.filter((row) => row.bingoName === hall)
      : [];
    if (searchValue.trim()) {
      const val = searchValue.trim().toLowerCase();
      const guestLabel = t('kiosk.guest').toLowerCase();
      if (searchType === 'username') {
        filtered = filtered.filter((row) => {
          const effective =
            row.username && row.username !== ''
              ? row.username.toLowerCase()
              : guestLabel;
          return effective.includes(val);
        });
      } else if (searchType === 'name') {
        filtered = filtered.filter((row) => {
          const effective =
            row.name && row.name !== '' ? row.name.toLowerCase() : guestLabel;
          return effective.includes(val);
        });
      } else if (searchType === 'userID') {
        filtered = filtered.filter((row) => {
          const effective = row.userID === 0 ? '-' : String(row.userID);
          return effective.includes(val);
        });
      } else if (searchType === 'ticketID') {
        filtered = filtered.filter((row) =>
          String(row.ticketSaleID || '').includes(val)
        );
      } else if (searchType === 'description') {
        filtered = filtered.filter((row) =>
          row.description?.toLowerCase().includes(val)
        );
      } else if (searchType === 'time') {
        filtered = filtered.filter((row) =>
          convertToMySQLDateTime(row.date).includes(val)
        );
      }
    }
    setRowsFiltered(filtered);
  }, [rows, searchType, searchValue]);

  function convertToMySQLDateTime(isoString) {
    const date = new Date(isoString);

    // Padding function to add leading zeros if necessary
    const pad = (number) => (number < 10 ? '0' + number : number);

    // Format the date using UTC methods
    const year = date.getUTCFullYear();
    const month = pad(date.getUTCMonth() + 1); // getUTCMonth() returns month from 0-11
    const day = pad(date.getUTCDate());
    const hours = pad(date.getUTCHours());
    const minutes = pad(date.getUTCMinutes());
    const seconds = pad(date.getUTCSeconds());

    return `${hours}:${minutes}:${seconds}`;
  }

  const handlePrint = (shoppingCart) => {
    socket.emit('printReceiptOnDemand', {
      printer: printer,
      action: 'printReceiptOnDemand',
      printInfo: shoppingCart.netsTicket,
    });
  };

  const handleSearch = () => {
    setIsLoading(true);
    socket.emit('getLastCardTransactions', { bingoName: hall, date });
  };

  return (
    <>
      {isBlocking && <BlockingScreen />}
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        sx={{
          maxWidth: '100%',
          maxHeight: '100%',
          width: '100%',
          height: '100%',
          overflow: 'hidden',
        }}
      >
        <Grid
          item
          xs={12}
          md={12}
          sx={{
            width: '100%',
            height: '100%',
          }}
        >
          <Grid
            container
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            {/* SEARCH BAR */}
            <Grid
              item
              xs={12}
              sx={{
                height: '190px',
                maxHeight: '190px',
                display: 'flex',
                alignItems: 'center',
                px: 3,
                gap: 2,
                borderBottom: '1px solid #2a3a6e',
              }}
            >
              <FormControl
                sx={{
                  minWidth: 180,
                  backgroundColor: '#232a45',
                  borderRadius: '4px',
                }}
              >
                <InputLabel
                  sx={{ color: 'white !important', fontSize: '20px' }}
                >
                  {t('ticketHistoric.searchType')}
                </InputLabel>
                <MuiSelect
                  MenuProps={touchMenuProps}
                  value={searchType}
                  label={t('ticketHistoric.searchType')}
                  onChange={(e) => setSearchType(e.target.value)}
                  sx={{
                    color: 'white',
                    height: '90px',
                    fontSize: '24px',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#365ab8',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#fcad89',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#fcad89',
                    },
                    '& .MuiSvgIcon-root': { color: 'white' },
                  }}
                >
                  <MenuItem value="username">
                    {t('sisteSalgs.username')}
                  </MenuItem>
                  <MenuItem value="name">{t('pep.name')}</MenuItem>
                  <MenuItem value="userID">{t('sisteSalgs.userID')}</MenuItem>

                  <MenuItem value="description">
                    {t('sisteTrans.description')}
                  </MenuItem>
                  <MenuItem value="time">{t('sales.time')}</MenuItem>
                </MuiSelect>
              </FormControl>

              <TextField
                sx={{
                  flex: 1,
                  backgroundColor: '#232a45',
                  '& .MuiOutlinedInput-root': {
                    height: '90px',
                    '& fieldset': { borderColor: '#365ab8' },
                    '&:hover fieldset': { borderColor: '#fcad89' },
                    '&.Mui-focused fieldset': { borderColor: '#fcad89' },
                  },
                  '& input': { color: 'white', fontSize: '24px' },
                  '& label': { color: 'white !important', fontSize: '20px' },
                  '& label.Mui-focused': { color: 'white !important' },
                  '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
                    transform: 'translate(14px, 30px) scale(1)',
                  },
                }}
                label={searchTypeLabel[searchType] || ''}
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                autoFocus
                autoComplete="off"
                variant="outlined"
              />

              <TextField
                type="date"
                label={t('sales.searchByDate')}
                value={date}
                onChange={(e) => setDate(e.target.value)}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                inputRef={dateInputRef}
                onClick={() => dateInputRef.current?.showPicker?.()}
                sx={{
                  width: '310px',
                  backgroundColor: '#232a45',
                  cursor: 'pointer',
                  '& .MuiOutlinedInput-root': {
                    height: '90px',
                    cursor: 'pointer',
                    '& fieldset': { borderColor: '#365ab8' },
                    '&:hover fieldset': { borderColor: '#fcad89' },
                    '&.Mui-focused fieldset': { borderColor: '#fcad89' },
                  },
                  '& input': {
                    color: 'white',
                    fontSize: '24px',
                    colorScheme: 'dark',
                    cursor: 'pointer',
                  },
                  '& label': { color: 'white !important', fontSize: '20px' },
                  '& label.Mui-focused': { color: 'white !important' },
                }}
              />

              <TouchButton
                tone="confirm"
                onClick={handleSearch}
                startIcon={<SearchIcon />}
                sx={{ height: '90px', minWidth: '160px', flexShrink: 0 }}
              >
                {t('menu.search')}
              </TouchButton>
            </Grid>
            {/*TABLE*/}
            <Grid
              item
              xs={12}
              sx={{
                width: '100%',
                padding: '10px',
                height: '100%',
              }}
            >
              {isLoading ? (
                <TableLoader />
              ) : (
                <TableContainer
                  component={Paper}
                  className="sp-scroll"
                  sx={{
                    maxHeight: 'calc(100% - 20px)',
                    marginBottom: '190px',
                    backgroundColor: '#1a2240',
                    overflowY: 'auto',
                  }}
                >
                  <Table
                    sx={{
                      color: 'white',
                      background: '#1a2240',
                    }}
                    stickyHeader
                    aria-label="simple table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell sx={headerCellSx} align="center">
                          {t('sales.time')}
                        </TableCell>
                        {/*
                      <TableCell align="center">
                        {t('sisteTrans.operator')}
                      </TableCell>
                      <TableCell align="center">
                        {t('sisteTrans.ticket7Pincode')}
                      </TableCell>
                      <TableCell align="center">
                        {t('sisteTrans.ticketID')}
                      </TableCell>
                      {/*
                      <TableCell align="center">
                        {t("sisteTrans.username")}
                      </TableCell>
                          <TableCell sx={headerCellSx} align="center">
                          {t('sales.ticketSaleID')}
                        </TableCell>
                      */}

                        <TableCell sx={headerCellSx} align="center">
                          {t('sisteSalgs.userID')}
                        </TableCell>
                        <TableCell sx={headerCellSx} align="center">
                          {t('sisteSalgs.username')}
                        </TableCell>
                        <TableCell sx={headerCellSx} align="center">
                          {t('pep.name')}
                        </TableCell>

                        <TableCell sx={headerCellSx} align="center">
                          {t('sisteSalgs.total')}
                        </TableCell>
                        <TableCell sx={headerCellSx} align="center">
                          {t('sisteTrans.description')}
                        </TableCell>
                        <TableCell sx={headerCellSx} align="center"></TableCell>
                      </TableRow>
                    </TableHead>
                    {rowsFiltered && (
                      <TableBody>
                        {rowsFiltered.map((row, index) => (
                          <>
                            {row.bingoName !== hall ? (
                              <></>
                            ) : (
                              <TableRow
                                key={index}
                                sx={dataRowSx}
                              >
                                <TableCell
                                  component="th"
                                  scope="row"
                                  align="center"
                                >
                                  {convertToMySQLDateTime(row.date)}
                                </TableCell>

                                {/*
                                <TableCell align="center">
                                  {row.ticketSaleID || '—'}
                                </TableCell>
                                */}
                                <TableCell align="center">
                                  {row.userID === 0 ? '—' : row.userID}
                                </TableCell>
                                <TableCell align="center">
                                  {row.username === '' || !row.username
                                    ? t('kiosk.guest')
                                    : row.username}
                                </TableCell>
                                <TableCell align="center">
                                  {row.name === '' || !row.name
                                    ? t('kiosk.guest')
                                    : row.name}
                                </TableCell>

                                <TableCell align="center">
                                  <Box
                                    sx={{ color: '#8fa3d4', fontWeight: 600 }}
                                  >
                                    {row.amount}
                                  </Box>
                                </TableCell>
                                <TableCell align="center">
                                  {row.description}
                                </TableCell>
                                <TableCell align="center">
                                  <TouchButton
                                    tone="info"
                                    sx={{ minWidth: 90, height: 52, fontSize: 17, px: 1.5 }}
                                    onClick={() => {
                                      handlePrint(row);
                                    }}
                                  >
                                    {t('sisteSalgs.printAgain')}
                                  </TouchButton>
                                </TableCell>
                              </TableRow>
                            )}
                          </>
                        ))}
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default SisteKortTransaksjoner;
